import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { formatNumber } from "../../utils/common";
import { useTranslation } from "react-i18next";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

function BarVeriticalStack({ data, t }) {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const labels = data.map((item) => item.year);

  const membershipFeesData = data.map((item) =>
    Math.floor(item.membershipFees)
  );
  const contributionRepresentativesData = data.map((item) =>
    Math.floor(item.contributionRepresentatives)
  );
  const publicFundingData = data.map((item) => Math.floor(item.publicFunding));
  const donationsData = data.map((item) => Math.floor(item.donations));
  const othersData = data.map((item) => Math.floor(item.others));

  const backgroundColors = {
    membershipFees: "#D3D3D3",
    contributionRepresentatives: "#E88B00",
    publicFunding: "#71C0DB",
    donations: "#561D25",
    others: "#84569A",
  };

  const chartData = {
    labels,
    datasets: [
      {
        label: t("membershipFees"),
        data: membershipFeesData,
        backgroundColor: backgroundColors.membershipFees,
        stack: "Stack 0", // Use same stack for all 3 datasets
      },
      {
        label: t("contributionRepresentatives"),
        data: contributionRepresentativesData,
        backgroundColor: backgroundColors.contributionRepresentatives,
        stack: "Stack 0",
      },
      {
        label: t("publicFunding"),
        data: publicFundingData,
        backgroundColor: backgroundColors.publicFunding,
        stack: "Stack 0",
      },
      {
        label: t("donations"),
        data: donationsData,
        backgroundColor: backgroundColors.donations,
        stack: "Stack 0",
      },
      {
        label: t("others"),
        data: othersData,
        backgroundColor: backgroundColors.others,
        stack: "Stack 0",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 0, // adjust this value as needed to provide enough room for the labels
      },
    },
    scales: {
      x: {
        grid: {
          drawOnChartArea: false,
          drawBorder: false,
          display: false,
        },
        ticks: {
          color: "black",
        },
      },
      y: {
        beginAtZero: true,
        maxTicksLimit: 6,
        ticks: {
          display: true,
          color: "black",
        },
        grid: {
          drawBorder: false,
          display: false, // This hides the horizontal grid lines
        },
        stacked: true,
      },
    },
    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += formatNumber(context.parsed.y, language) + "€";
            }
            return label;
          },
        },
      },
      datalabels: {
        display: false,
        // anchor: "end",
        // align: "top",
        // offset: 0, // Adjust as needed
        // formatter: function (value, context) {
        //   const totalData = context.chart.data.datasets;
        //   const dataIndex = context.dataIndex;
        //   // Only show the label for the topmost dataset (in this case the "others" dataset which is at index 4)
        //   if (context.datasetIndex === 4) {
        //     let sum = 0;
        //     totalData.forEach((dataset) => {
        //       sum += dataset.data[dataIndex] || 0; // Add the data value of each dataset at the current index
        //     });
        //     return formatNumber(sum.toString(), language); // Format the sum and return
        //   }
        //   return ""; // For other datasets, return an empty string
        // },
        // color: "black",
        // display: function (context) {
        //   return context.datasetIndex === 4; // Only display label for the topmost dataset
        // },
      },
    },
  };

  return <Bar options={options} data={chartData} />;
}

export default BarVeriticalStack;
